import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Meta Pixel ID (configurar no .env)
    const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
    
    // Google Analytics ID (configurar no .env)
    const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

    // Inicializar Meta Pixel
    if (META_PIXEL_ID && !window.fbq) {
      (function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      })(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      
      window.fbq('init', META_PIXEL_ID);
    }

    // Inicializar Google Analytics
    if (GA_MEASUREMENT_ID && !window.gtag) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID);
    }

    // Track PageView em toda mudança de rota
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search
      });
    }

  }, [location]);

  return null; // Componente invisível
};

// Funções auxiliares para tracking de eventos
export const trackEvent = (eventName, eventData = {}) => {
  // Meta Pixel
  if (window.fbq) {
    window.fbq('track', eventName, eventData);
    console.log('📊 Meta Pixel:', eventName, eventData);
  }
  
  // Google Analytics
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
    console.log('📊 Google Analytics:', eventName, eventData);
  }
};

// Eventos de E-commerce específicos
export const trackViewContent = (product) => {
  trackEvent('ViewContent', {
    content_name: product.name,
    content_category: product.category,
    content_ids: [product.id],
    content_type: 'product',
    value: product.price,
    currency: 'BRL'
  });
};

export const trackAddToCart = (product, quantity = 1) => {
  trackEvent('AddToCart', {
    content_name: product.name,
    content_ids: [product.id],
    content_type: 'product',
    value: product.price * quantity,
    currency: 'BRL',
    contents: [{
      id: product.id,
      quantity: quantity
    }]
  });
};

export const trackInitiateCheckout = (cart, total) => {
  trackEvent('InitiateCheckout', {
    content_ids: cart.map(item => item.id),
    contents: cart.map(item => ({
      id: item.id,
      quantity: item.quantity
    })),
    num_items: cart.reduce((sum, item) => sum + item.quantity, 0),
    value: total,
    currency: 'BRL'
  });
};

export const trackPurchase = (orderId, cart, total, discount = 0) => {
  trackEvent('Purchase', {
    content_ids: cart.map(item => item.id),
    contents: cart.map(item => ({
      id: item.id,
      quantity: item.quantity
    })),
    value: total,
    currency: 'BRL',
    transaction_id: orderId,
    num_items: cart.reduce((sum, item) => sum + item.quantity, 0),
    discount: discount
  });
};

export const trackSearch = (searchQuery) => {
  trackEvent('Search', {
    search_string: searchQuery
  });
};

export const trackLead = (email, phone) => {
  trackEvent('Lead', {
    content_name: 'Contact Form',
    email: email,
    phone: phone
  });
};

export default Analytics;
